import Vue from 'vue'
import Router from 'vue-router'
// Import Guard
import guard from '@/routes/guard/guard'
// Import Modules
import dashboardRoutes from './modules/dashboard'
import authRoutes from './modules/auth'

// Add plugin Router to Vue
Vue.use(Router)

const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        ...dashboardRoutes,
        ...authRoutes,
    ],
})

// Global guard for router ( redirect to Login if user is not authenticated)
router.beforeEach(guard)

export default router
